import { masks, onlyNumbers } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../final-form/MaskedField'

export function CnpjField(props: MaskedFieldProps) {
  return <MaskedField mask={masks.cnpj} placeholder='00.000.000/0000-00' parse={onlyNumbers} {...props} />
}
